/**
 * Shared fetch helper for workspace-scoped API calls. Injects the auth token and
 * the active workspace header (same localStorage keys AuthContext writes).
 */
const API_BASE = "/api/v1";

interface Envelope<T> {
  success: boolean;
  message: string;
  data: T;
}

function headers(extra: Record<string, string> = {}): Record<string, string> {
  const token = localStorage.getItem("auth_token");
  const ws = localStorage.getItem("active_workspace_id");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(ws ? { "X-Workspace-Id": ws } : {}),
    ...extra,
  };
}

async function request<T>(method: string, url: string, body?: unknown): Promise<T> {
  const res = await fetch(`${API_BASE}${url}`, {
    method,
    headers: headers(),
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  const json = (await res.json()) as Envelope<T>;
  if (!res.ok || !json.success) throw new Error(json.message || "Request failed");
  return json.data;
}

export const apiGet = <T>(url: string) => request<T>("GET", url);
export const apiPost = <T>(url: string, body?: unknown) => request<T>("POST", url, body);
export const apiPatch = <T>(url: string, body?: unknown) => request<T>("PATCH", url, body);
export const apiPut = <T>(url: string, body?: unknown) => request<T>("PUT", url, body);
export const apiDelete = <T>(url: string, body?: unknown) => request<T>("DELETE", url, body);
